import { Size } from '../../../styles/theme.mjs';
import styled from 'styled-components';

const StyledProgressButton = styled.button `
  display: grid;
  align-items: center;
  white-space: nowrap;
  border-radius: 4px;
  color: ${props => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.slate; }};
  background-color: ${props => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : props.theme.colors.white; }}3C;
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  overflow: hidden;
  padding: 0;
  outline: none;
  border: none;

  svg {
    margin-bottom: 2px;
    transform: ${props => { var _a, _b; return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.transform; }};
  }
`;
const StyledProgress = styled.div `
  grid-area: 1 / 1;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.colors.white};
  animation: ${props => props.theme.keyframes.progress}
    ${props => props.theme.animation.easing.productive.standard}
    ${props => props.playNextAfter / 1000}s;
`;
const StyledChildrenContainer = styled.div `
  display: flex;
  justify-self: center;
  align-items: center;
  grid-area: 1 / 1;
  gap: ${props => { var _a, _b; return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.gap; }};
  outline: none;
  border: none;
  cursor: pointer;
  align-self: center;
  font-size: ${props => { var _a; return (_a = props.theme.interactive.button[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.fontSize; }};
  line-height: ${props => { var _a; return (_a = props.theme.interactive.button[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.lineHeight; }};
  padding: ${props => { var _a, _b; return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.padding.sm.symmetrical; }};

  svg {
    transform: ${props => { var _a, _b; return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.transform; }};
  }
`;

export { StyledChildrenContainer, StyledProgress, StyledProgressButton };
//# sourceMappingURL=ProgressButton.styles.mjs.map
